import HttpRequest from "@/api/axios";

const axios = new HttpRequest(process.env.VUE_APP_API_BASE_URL1);

export default {
    vote(params) {
        return axios.request({
            url: `sports-item-user/vote`,
            method: 'post',
            data: params
        });
    },
    getVoteDetail(id) {
        return axios.request({
            url: `sports-item-user/${id}?expand=sportsItem,sportsItemSub,userInfo`,
            method: 'get'
        });
    },
    sportsMain(data) {
        return axios.request({
            url: `sports/${data.sports_id}?expand=items`,
            method: "get",
            data
        });
    },
    getSportsItemRank(params) {
        return axios.request({
            url: 'sports-item/rank',
            method: 'get',
            params
        });
    },
    getMySportsItemRank(params) {
        return axios.request({
            url: 'sports-item/my-rank',
            method: 'get',
            params
        });
    },
    getLinks(data) {
        return axios.request({
            url: `externallink-config/${data.id}`,
            method: "get",
            params:data
        });
    }
}